import * as React from "react";

const IconMail: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12" fill="currentColor">
            <path
                fill="currentColor"
                d="M1.5,2.71249962 L8,7.18124962 L14.5,2.71249962 L14.5,1.5 L1.5,1.5 L1.5,2.71249962 Z M14.5,4.53125 L8,9 L1.5,4.53125 L1.5,10.5 L14.5,10.5 L14.5,4.53125 Z M0,10.5 L0,3.5 L0,1.5 L0,0 L1.5,0 L14.5,0 L16,0 L16,1.5 L16,3.5 L16,10.5 L16,12 L14.5,12 L1.5,12 L0,12 L0,10.5 Z"
            />
        </svg>
    );
};

export default React.memo(IconMail);
